"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = exports.FINGERPRINT = exports.ClientApp = exports.LatencyResult = exports.StatusCode = exports.MethodCallResult = exports.TransportType = exports.MethodName = exports.ServiceName = exports.AvroOptional = void 0;
const signals_logger_1 = require("@indeed/signals-logger");
const ServiceName_1 = require("./ServiceName");
Object.defineProperty(exports, "ServiceName", { enumerable: true, get: function () { return ServiceName_1.ServiceName; } });
const MethodName_1 = require("./MethodName");
Object.defineProperty(exports, "MethodName", { enumerable: true, get: function () { return MethodName_1.MethodName; } });
const TransportType_1 = require("./TransportType");
Object.defineProperty(exports, "TransportType", { enumerable: true, get: function () { return TransportType_1.TransportType; } });
const MethodCallResult_1 = require("./MethodCallResult");
Object.defineProperty(exports, "MethodCallResult", { enumerable: true, get: function () { return MethodCallResult_1.MethodCallResult; } });
const StatusCode_1 = require("./StatusCode");
Object.defineProperty(exports, "StatusCode", { enumerable: true, get: function () { return StatusCode_1.StatusCode; } });
const LatencyResult_1 = require("./LatencyResult");
Object.defineProperty(exports, "LatencyResult", { enumerable: true, get: function () { return LatencyResult_1.LatencyResult; } });
const ClientApp_1 = require("./ClientApp");
Object.defineProperty(exports, "ClientApp", { enumerable: true, get: function () { return ClientApp_1.ClientApp; } });
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "90159d4bcdda7eca";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
exports.log = log;
